import React from 'react';
import { ClipboardDocumentListIcon, UserPlusIcon, CurrencyDollarIcon } from '@heroicons/react/24/outline';
import { formatDistanceToNow } from 'date-fns';
import { id } from 'date-fns/locale';

interface Activity {
  id: number;
  type: string;
  description: string;
  date: string;
}

interface RecentActivityProps {
  activities?: Activity[];
}

export const RecentActivity: React.FC<RecentActivityProps> = ({ activities = [] }) => {
  return (
    <div className="bg-white shadow-sm rounded-xl border border-gray-100 overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-50 bg-gray-50/50">
        <h3 className="text-lg font-semibold text-gray-800">Aktivitas Terbaru</h3>
      </div>
      <div className="p-0">
        {activities.length === 0 ? (
          <div className="p-6 text-center text-gray-500 py-8 bg-gray-50/30 rounded-lg border border-dashed border-gray-200 m-6">
            <ClipboardDocumentListIcon className="h-10 w-10 mx-auto mb-3 text-gray-300" />
            <p className="text-sm font-medium">Belum ada aktivitas terbaru</p>
          </div>
        ) : (
          <ul className="divide-y divide-gray-100">
            {activities.map((activity) => (
              <li key={activity.id} className="p-4 hover:bg-gray-50 transition-colors">
                <div className="flex items-center space-x-4">
                  <div className={`p-2 rounded-full ${activity.type === 'payment' ? 'bg-green-100 text-green-600' : 'bg-blue-100 text-blue-600'}`}>
                    {activity.type === 'payment' ? <CurrencyDollarIcon className="h-5 w-5" /> : <UserPlusIcon className="h-5 w-5" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-gray-900 truncate">
                      {activity.description}
                    </p>
                    <p className="text-xs text-gray-500">
                      {formatDistanceToNow(new Date(activity.date), { addSuffix: true, locale: id })}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
